import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
function Copyright() {
  return (
    <Box>
        <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Multibase Systems Ltd
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
    {/* <Typography className="websiteby" style={{fontSize: 10}} align="center">Website made by Samantha Grace Design</Typography> */}
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));


export default function Footer() {

  const classes = useStyles();
  return(
    <React.Fragment>
  {/* Footer */}
  <footer className={classes.footer}>
  <Typography variant="h6" align="center" gutterBottom>
    Get in contact today
  </Typography>
  <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
    info@multibase.co.uk or call us at 0345 459 0001
  </Typography>
  <Copyright />
</footer>
{/* End footer */}
</React.Fragment>
);
}